export default class Table {
  constructor() {
    $('table').wrap('<div class="table-wrap"></div>');
  }
}
